import { CacheStrategy } from '@rammetec/data-access';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { TAG_LINK } from '../types/tag.js';
export const tagLinkDescriptor = {
    name: TAG_LINK,
    label: 'Vínculo de tag',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/tagLink',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 1,
    description: 'Association between a tag and an entity',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique tag link identifier',
        },
        {
            name: 'tagId',
            label: 'Tag',
            type: 'string',
            required: true,
            description: 'Reference to the tag',
        },
        {
            name: 'entity',
            label: 'Entidade',
            type: 'string',
            required: true,
            description: 'Entity type name (e.g. Product)',
        },
        {
            name: 'entityId',
            label: 'ID da Entidade',
            type: 'string',
            required: true,
            description: 'Entity record ID',
        },
    ],
    foreignKeys: [
        {
            fieldName: 'tagId',
            targetEntity: 'Tag',
            relationship: 'many-to-one',
            description: 'The tag linked to the entity',
            displayField: 'name',
        },
    ],
};
//# sourceMappingURL=tag-link.descriptor.js.map